<app-header></app-header>
<app-navbar [selected]="'administration'"></app-navbar>

<div class="d-flex">
    <aside role="complementary" [attr.aria-label]="'asideDescription' | translate">
        <app-sidebar [items]="links" [subItems]="subLinks"></app-sidebar>
    </aside>
    <main class="ps-5 w-100 ">
        <div class="row">
            <div class="col-md-6 fw-bold">
                <label for="basic-url" class="form-label color-text"> {{ 'tariffServices.text-service' | translate }}
                </label>
            </div>
            <div class="col-md-6 text-end">
                <button type="button" class="btn custombutton" (click)="checkRow()">{{ 'tariffServices.newService' |
                    translate}}</button>
            </div>
        </div>
        @if (this.serviceReponse.listService && this.serviceReponse.listService.length > 0) {
        <div>
            <fieldset role="radiogroup">
                <table class="table text-center mt-2" role="grid"
                    [attr.aria-label]="'tariffServices.text-service' | translate">

                    <thead>
                        <tr role="row">
                            <th scope="col">
                                <span class="visually-hidden">{{ 'seleccionarFila' | translate }}</span>
                            </th>
                            <th scope="col">{{ 'tariffServices.codeService' | translate }}</th>
                            <th scope="col">{{ 'tariffRole.descripcion' | translate }}</th>
                            <th scope="col">{{ 'tariffUsers.checkActive' | translate }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let service of this.serviceReponse.listService; let i = index"
                            [ngClass]="{'resaltado': selectedRowId === service.idService}" role="row">
                            <td role="gridcell">
                                <input type="radio" name="flexRadioDefault" [id]="'flexRadioDefault' + i"
                                    [checked]="selectedRowId === service.idService" (click)="checkRow(service)">
                                <label [for]="'flexRadioDefault' + i" class="visually-hidden">
                                    {{ 'seleccionarFilaCon' | translate }}:
                                    {{ 'tariffServices.codeService' | translate }} {{ service.codeService }},
                                    {{ 'tariffRole.descripcion' | translate }} {{
                                    service.serviceTraductionDto[0].shortDescription }},
                                    {{ 'tariffUsers.checkActive' | translate }} {{ service.active === 'S' ?
                                    ('model.active'
                                    | translate) : ('model.inactive' | translate) }}
                                </label>
                            </td>
                            <td role="gridcell">
                                <span>{{ service.codeService }}</span>
                            </td>
                            <td role="gridcell">
                                <span>{{ service.serviceTraductionDto[0].shortDescription }}</span>
                            </td>
                            <td role="gridcell">
                                @if(service.active == 'S') {
                                <span>{{'model.active' | translate}}</span>
                                }@else{
                                <span>{{'model.inactive' | translate}}</span>
                                }
                            </td>
                        </tr>
                    </tbody>
                </table>
            </fieldset>

            <div class="mt-2" *ngIf="this.serviceReponse.pageDto">
                <app-paginator [isStart]="this.serviceReponse.pageDto.start" [isEnd]="this.serviceReponse.pageDto.end"
                    [currentPage]="this.serviceReponse.pageDto.currentPage"
                    [totalPages]="this.serviceReponse.pageDto.pages"
                    [numberRecord]="this.serviceReponse.pageDto.records"
                    [sizePage]="this.serviceReponse.pageDto.pageSize">
                </app-paginator>
            </div>
        </div>
        }
        @if (this.selectedRowId || isCreate) {
        <div class="separator mt-5"></div>

        <div>
            <form [formGroup]="serviceForm" (ngSubmit)="createOrUpdateService()">
                <div class="mt-5">
                    @if(!this.selectedRowId){
                    <h2 class="textformat mb-4 color-text">{{ 'tariffServices.newService'
                        | translate }}</h2>
                    }@else {
                    <h2 class="textformat mb-4 color-text">{{
                        'tariffServices.updateService' | translate }}</h2>
                    }
                </div>

                <div class="row">
                    <div class="col-md-6 mb-3">
                        <label class="form-label" for="codeService">{{ 'tariffServices.codeService' | translate }}<span>
                                *</span></label>
                        <input type="text" class="form-control color-text" name="codeService" id="codeService" required
                            formControlName="codeService"
                            [class.input-error]="sharedService.controlInput(serviceForm,'codeService')">
                        <app-message-input [form]="serviceForm" [field]="'codeService'"></app-message-input>

                    </div>

                    <div class="col-md-6 mb-3">
                        <label for="descriptionCas" class="form-label">{{ 'model.descriptionCast' | translate }}<span>
                                *</span></label>
                        <input type="text" class="form-control color-text" id="descriptionCas" name="descriptionCas"
                            required formControlName="descriptionCas"
                            [class.input-error]="sharedService.controlInput(serviceForm,'descriptionCas')">
                        <app-message-input [form]="serviceForm" [field]="'descriptionCas'"></app-message-input>

                    </div>

                    <div class="col-md-6 mb-3">
                        <label for="descriptionCat" class="form-label">{{ 'model.descriptionCat' | translate }}<span>
                                *</span></label>
                        <input type="text" class="form-control color-text" id="descriptionCat" name="descriptionCat"
                            required formControlName="descriptionCat"
                            [class.input-error]="sharedService.controlInput(serviceForm,'descriptionCat')">
                        <app-message-input [form]="serviceForm" [field]="'descriptionCat'"></app-message-input>
                    </div>

                    <div class="col-md-6 mb-3">
                        <label for="descriptionEng" class="form-label">{{ 'model.descriptionEng' | translate }}<span>
                                *</span></label>
                        <input type="text" class="form-control color-text" id="descriptionEng" name="descriptionEng"
                            required formControlName="descriptionEng"
                            [class.input-error]="sharedService.controlInput(serviceForm,'descriptionEng')">
                        <app-message-input [form]="serviceForm" [field]="'descriptionEng'"></app-message-input>

                    </div>

                    <div class="col-md-6 mb-3">
                        <input class="form-check-input mx-3" type="checkbox" id="active" name="active"
                            formControlName="active">
                        <label class="form-check-label color-text" for="active">
                            {{ 'model.active' | translate }}
                        </label>
                    </div>
                </div>
                @if(!this.selectedRowId){
                <button type="submit" class="btn custombutton mt-3">{{ 'tariffServices.newService' | translate
                    }}</button>
                }@else {
                <button type="submit" class="btn custombutton mt-3 mx-2">{{ 'tariffServices.updateService' | translate
                    }}</button>
                }
                <app-alert-component [isOk]="messageVisibility.isSuccessFirst"
                    [isDanger]="messageVisibility.isErrorFirts" [message]="errorMessage"
                    (close)="messageVisibility.isSuccessFirst = messageVisibility.isErrorFirts = false"></app-alert-component>
            </form>
        </div>
        }
    </main>
</div>